module.exports = __webpack_public_path__ + "img/team-3.54e3f3c4.jpg";